"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prependMessageToError = exports.cloneError = exports.ignoreIfThrows = exports.catchIfThrows = void 0;
const catchIfThrows = (fn, errorHandler) => function (...args) {
    try {
        const result = fn(...args);
        // if passed "fn" is async, in order to catch a rejection we'd need to await for it
        // using "await fn(...args)" would be wrong because sync function will start behaving as if they were async
        // thus we keep the execution sync unless result is "thenable"
        if ((result === null || result === void 0 ? void 0 : result.then) && result.catch) {
            return result.catch((error) => errorHandler(error, ...args));
        }
        return result;
    }
    catch (error) {
        errorHandler(error, ...args);
    }
};
exports.catchIfThrows = catchIfThrows;
const ignoreIfThrows = (fn) => (0, exports.catchIfThrows)(fn, () => null);
exports.ignoreIfThrows = ignoreIfThrows;
const cloneError = (originalError) => {
    // @ts-expect-error
    const error = new originalError.constructor();
    const propsToCopy = ['message', 'stack', 'name', 'filename', 'lineNumber', 'columnNumber'];
    for (const prop of propsToCopy) {
        if (originalError[prop]) {
            error[prop] = originalError[prop];
        }
    }
    return error;
};
exports.cloneError = cloneError;
const prependMessageToError = (error, message) => {
    const errorClone = (0, exports.cloneError)(error);
    errorClone.message = `${message} ${errorClone.message}`;
    return errorClone;
};
exports.prependMessageToError = prependMessageToError;
//# sourceMappingURL=errorHandling.js.map